
import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import AvatarEdit from '../../../business-components/Avatar/AvatarEdit'

import AvatarView from '../../../business-components/Avatar/AvatarView'

import {
    GridContainer,
    GridItem4xs12,
    GridItem8xs12,
} from '../../../business-components/Grid/Grid'

import {
    IconButtonClearEntradaDados
} from '../../../business-components/IconButton/IconButton'

import {
    SvgImageHomem,
    SvgImageMulher,
} from '../../../business-components/SvgImage/SvgImage'



const AvatarClienteConjugeFamiliarPadrao = ({ sexo }) => {

    return (
        sexo === HARDCODE.idSexoMasculino
            ?
                <SvgImageHomem
                    fontSize="large"
                />
            :
                <SvgImageMulher
                    fontSize="large"
                />
    )
}

export const AvatarClienteConjugeFamiliarView = ({ value, sexo }) => {

    return (
        value
            ?
                <AvatarView
                    width={110}
                    height={110}
                    value={value}
                />
            :
                <AvatarClienteConjugeFamiliarPadrao
                    sexo={sexo}
                />
    )
}

export const AvatarClienteConjugeFamiliar = ({ name, value, setFieldValue, sexo }) => {

    return (
        sexo
            ?
                <GridContainer
                    className='mt-1 mb-3'
                >
                    <GridItem4xs12
                        className='text-center'
                    >
                        <AvatarClienteConjugeFamiliarView
                            value={value}
                            sexo={sexo}
                        />
                        {value && (
                            <IconButtonClearEntradaDados
                                className='mt--15'
                                onClick={() =>
                                    setFieldValue(name, '')
                                }
                            />
                        )}
                    </GridItem4xs12>

                    <GridItem8xs12
                        align='center'
                    >
                        <AvatarEdit
                            name={name}
                            setFieldValue={setFieldValue}
                        />
                    </GridItem8xs12>
                </GridContainer>
            :
                ''
    )
}